import { useState, useEffect } from "react";
import Card from "components/card";
import { MdCreate, MdDelete, MdUpload } from "react-icons/md";
import { toast, ToastContainer } from "react-toastify";
import { deleteTrainerstDataApi, getTrainerDataApi, addTrainerstDataApi, editTrainerstDataApi, trainerToggleApi } from "Services/allApi";
import Swal from "sweetalert2";

const TrainerCard = ({ extra, defimage }) => {
  const [trainerData, setTrainerData] = useState([]);
  const [images, setImages] = useState(null);
  const [description, setDescription] = useState("");
  const [name, setName] = useState("");
  const [index, setIndex] = useState("");
  const [role, setRole] = useState("");
  const [linkedin_url, setLinkedin_url] = useState("");
  const [instagram_url, setInstagram_url] = useState("");
  const [youtube_url, setYoutube_url] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [currentTrainerId, setCurrentTrainerId] = useState(null);
  const [trainers, setTrainers] = useState([]);


  const fetchTrainers = async () => {


    try {
      const response = await getTrainerDataApi();
      if (!response.error) {

        setTrainerData(response.data);
      }
    } catch (error) {
      console.error("Error fetching trainers:", error);
    }
  };

  useEffect(() => {
    fetchTrainers();
  }, []);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImages(file);
    }
  };

  const handleEdit = (trainer) => {
    setImages(null);
    setDescription(trainer.domain || "");
    setLinkedin_url(trainer.linkedin_url || "");
    setInstagram_url(trainer.instagram_url || "");
    setYoutube_url(trainer.youtube_url || "");
    setName(trainer.name || "");
    setIndex(trainer.index || "");
    setRole(trainer.role || "");
    setCurrentTrainerId(trainer.id);
    setIsModalOpen(true);
  };

  const handleAdd = () => {
    setImages(null); 
    setDescription("");
    setName("");
    setIndex("");
    setRole("");
    setLinkedin_url("");
    setInstagram_url("");
    setYoutube_url("");
    setCurrentTrainerId(null); 
    setIsAddModalOpen(true); 
  };

  const handleSave = async () => {
    const formData = new FormData();
    if (images) {
      formData.append("image", images);
    }
    formData.append("index", index);
    formData.append("name", name);
    formData.append("domain", description);
    formData.append("role", role);
    formData.append("linkedin_url", linkedin_url);
    formData.append("instagram_url", instagram_url);
    formData.append("youtube_url", youtube_url);

    try {
      if (isAddModalOpen) {
        const response = await addTrainerstDataApi(formData);
        if (!response.error) {
          setTrainerData((prevData) => [...prevData, response.data]);
          toast.success("Trainer added successfully");
        } else {
          toast.error(response.message);
        }
      } else if (isModalOpen && currentTrainerId) {
        const response = await editTrainerstDataApi(currentTrainerId, formData);
        if (!response.error) {
          setTrainerData((prevData) =>
            prevData.map((trainer) =>
              trainer.id === currentTrainerId ? response.data : trainer
            )
          );
          toast.success("Trainer updated successfully");
        } else {
          toast.error(response.message);
        }
      }
    } catch (error) {
      toast.error("Error saving trainer data");
    }

    setIsModalOpen(false);
    setIsAddModalOpen(false);
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this trainer?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      customClass: {
        popup: 'dark:bg-gray-800 dark:text-white', // Dark background and white text
        title: 'dark:text-white',
        confirmButton: 'dark:bg-blue-500 dark:hover:bg-blue-700 dark:text-white',
        cancelButton: 'dark:bg-red-500 dark:hover:bg-red-700 dark:text-white'
    }
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await deleteTrainerstDataApi(id);
          if (!response.error) {
            setTrainerData((prevData) => prevData.filter((trainer) => trainer.id !== id));
            toast.success("Trainer deleted successfully");
          } else {
            toast.error(response.message);
          }
        } catch (error) {
          toast.error("Error deleting trainer:", error);
        }
      }
    });
  };

 
  const handleCheckboxChange = async (id) => {
    try {
      const response = await trainerToggleApi(id);
      console.log(response);

      if (response) {
        const tName = response.data
        if(tName.disply_home_page==true){
          toast.info(`${tName.name} is added on Home page`)
        }
        else{
          toast.warning(`${tName.name} is removed from the Home page`)
        }
        // toast.success(`Status changed successfully for ${tName.name}!`);

        console.log("API Response:", response);
        fetchTrainers()
        
        setTrainers((prevTrainers) =>
          prevTrainers.map((trainer) =>
            trainer.id === id
              ? { ...trainer, disply_home_page: !trainer.disply_home_page }
              : trainer
          )
        );
      } else {
        toast.error("Failed to change status.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while changing the status.");
    }
  };







  const handleModalClose = () => {
    setIsModalOpen(false);
    setIsAddModalOpen(false);
  };

  return (
    <>
      <div className="mb-4 flex justify-end mt-4">
        <button
          onClick={handleAdd}
          className="bg-purple-800 text-white px-4 py-2 rounded-lg font-medium text-sm hover:bg-purple-700"
        >
          Add Trainer
        </button>
      </div>
      <div className="z-20 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {trainerData?.map((trainer) => (
          <Card
            key={trainer.id}
            extra={`flex flex-col w-full sm:w-4/5 lg:w-[280px] h-auto !p-4 bg-white shadow-md ${extra}`}
          >
            <div className="h-full w-full">
              <div className="relative w-full h-60 mb-4">
                <img
                  src={trainer.image || defimage}
                  alt="Trainer"
                  className="absolute top-0 left-0 w-full h-full object-cover rounded-xl"
                />
              </div>

              <div className="mb-4 w-full">
                <p className="text-lg font-bold text-black-700 dark:text-white">
                  {trainer.name || "Name"}
                </p>
              </div>
              <div className="mb-4 w-full">
                <p className="text-sm text-black-600 dark:text-gray-300">
                  {trainer.domain || "Domain"}
                </p>
              </div>
              <div className="mb-4 w-full">
                <p className="text-sm text-black-600 dark:text-gray-300">
                  {trainer.role || "Role"}
                </p>
              </div>

              <div className="mt-4">
                <div className="flex justify-between">
                  <button
                    onClick={() => handleEdit(trainer)}
                    className="rounded-lg bg-green-600 px-4 py-2 text-white font-medium text-sm transition duration-200 hover:bg-purple-700"
                  >
                    <MdCreate />
                  </button>
                  <button
                    onClick={() => handleDelete(trainer.id)}
                    className="rounded-lg bg-red-800 px-4 py-2 text-white font-medium text-sm transition duration-200 hover:bg-purple-600"
                  >
                    <MdDelete />
                  </button>
                </div>

                <div className="flex justify-between mt-3">
                  <label className="inline-flex items-center cursor-pointer mt-3">
                    <div className="me-2" style={{ fontSize: "12px" }}>
                      Do you want to display on Home Page
                    </div>
                    <input
                      type="checkbox"
                      checked={trainer.disply_home_page} // Reflect the true/false state
                      onChange={() => handleCheckboxChange(trainer.id)} // Bind the toggle handler
                      className="sr-only peer"
                    />
                    <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 rounded-full peer dark:bg-purple-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600 dark:bg-white"></div>
                  </label>
                </div>

              </div>
            </div>
          </Card>
        ))}
      </div>


      {(isModalOpen || isAddModalOpen) && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50 ">
          <div className="bg-white p-6 rounded-xl w-1/2 max-h-screen overflow-y-auto  dark:bg-gray-800 dark:text-white">
            <h2 className="text-lg font-semibold text-gray-700 dark:text-white">
              {isAddModalOpen ? "Add Trainer" : "Edit Trainer"}
            </h2>
            <div className="mt-4">
              {/* Two Inputs in a Row */}
              <div className="flex gap-4 mb-4">
              <div className="w-1/2">
                  <label className="block text-sm text-gray-700 dark:text-white">Index</label>
                  <input
                    type="number"
                    value={index}
                    onChange={(e) => setIndex(e.target.value)}
                    className="w-full mt-1 p-2 border rounded-md dark:bg-gray-800 dark:text-white dark:border-gray-600"
                  />
                </div>
                <div className="w-1/2">
                  <label className="block text-sm text-gray-700 dark:text-white">Name</label>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="w-full mt-1 p-2 border rounded-md  dark:bg-gray-800 dark:text-white dark:border-gray-600"
                  />
                </div>
                <div className="w-1/2">
                  <label className="block text-sm text-gray-700 dark:text-white">Domain</label>
                  <input
                    type="text"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    className="w-full mt-1 p-2 border rounded-md  dark:bg-gray-800 dark:text-white dark:border-gray-600"
                  />
                </div>
              </div>

              <div className="flex gap-4 mb-4">
                <div className="w-1/2">
                  <label className="block text-sm text-gray-700 dark:text-white">Role</label>
                  <input
                    type="text"
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                    className="w-full mt-1 p-2 border rounded-md  dark:bg-gray-800 dark:text-white dark:border-gray-600"
                  />
                </div>
                <div className="w-1/2">
                  <label className="block text-sm text-gray-700 dark:text-white">Youtube</label>
                  <input
                    type="url"
                    value={youtube_url}
                    onChange={(e) => setYoutube_url(e.target.value)}
                    className="w-full mt-1 p-2 border rounded-md  dark:bg-gray-800 dark:text-white dark:border-gray-600"
                  />
                </div>
              </div>

              {/* Social Media URLs */}
              <div className="flex gap-4 mb-4">
                <div className="w-1/2">
                  <label className="block text-sm text-gray-700 dark:text-white">LinkedIn</label>
                  <input
                    type="url"
                    value={linkedin_url}
                    onChange={(e) => setLinkedin_url(e.target.value)}
                    className="w-full mt-1 p-2 border rounded-md  dark:bg-gray-800 dark:text-white dark:border-gray-600"
                  />
                </div>
                <div className="w-1/2">
                  <label className="block text-sm text-gray-700 dark:text-white">Instagram</label>
                  <input
                    type="url"
                    value={instagram_url}
                    onChange={(e) => setInstagram_url(e.target.value)}
                    className="w-full mt-1 p-2 border rounded-md  dark:bg-gray-800 dark:text-white dark:border-gray-600"
                  />
                </div>
              </div>

              {/* Image Preview */}
              <div className="mb-4" style={{ justifyItems: "center", display: "flex" }}>
                <div>
                  {/* Image preview */}
                  <div className="mt-2">
                    {images && (
                      <img
                        src={URL.createObjectURL(images)}
                        alt="Preview"
                        className="w-20 h-20 object-cover "
                      />
                    )}
                    {!images && currentTrainerId && (
                      <img
                        src={trainerData.find((t) => t.id === currentTrainerId)?.image || defimage}
                        alt="Current"
                        className=" object-cover rounded "
                        style={{height:'100px',width:'100px'}}
                      />
                    )}
                  </div>
                </div>
                <div>
                  <label className="block text-sm ms-3 mt-3 text-gray-700 dark:text-white">Image</label>
                  {/* Hidden input field */}
                  <input
                    type="file"
                    id="file-upload"
                    onChange={handleImageChange}
                    accept="image/*"
                    className="hidden"
                  />

                  {/* MdUpload button */}
                  <button
                    onClick={() => document.getElementById("file-upload").click()}
                    className="flex items-center justify-center w-10 ms-3 mt-1 p-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
                  >
                    <MdUpload className="" style={{ width: '20px' }} />
                    
                  </button>
                  <p className="mt-2 ms-2" style={{fontSize:'10px'}}>The height and width must be 1080 × 1350</p>
                </div>



              </div>











              {/* Buttons */}
              <div className="flex justify-end gap-4 mt-6">
                <button
                  onClick={handleModalClose}
                  className="bg-gray-500 text-white px-4 py-2 rounded-lg"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSave}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg"
                >
                  {isAddModalOpen ? "Save" : "Update"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeButton={true} />
    </>
  );
};

export default TrainerCard;
